import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withPagination } from '../../shared/store/pagination.feature';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { avecMéthodesRéférentielLivrables } from './référentiel-livrable.methods';
import { avecSélecteursRéférentielLivrables } from './référentiel-livrable.selectors';
import { initialState, RéférentielLivrableState } from './référentiel-livrable.state';
import { RéférentielLivrable } from '../../administration/gestion-référentiels/models/référentiel-livrable.model';

export const RéférentielLivrableStore = signalStore(
  { providedIn: 'root' },
  withEntities<RéférentielLivrable>(),
  withState<RéférentielLivrableState>(initialState),
  withSelectedEntity(),
  withPagination<RéférentielLivrable>(),
  avecMéthodesRéférentielLivrables(),
  avecSélecteursRéférentielLivrables(),
);
